import React, {useState} from 'react';

import {useTranslation} from 'react-i18next';

import {
  XStack,
  Typography,
  ShellTrans,
  useCurrentUser,
  useIsAuthenticated,
  DropdownItem,
  Dropdown,
  useAppDirection,
  Avatar,
  useAuth,
  View,
} from '@medad-sep/core';
import {LanguageLabel} from '@shared/components/AppTopBar/LanguageLabel';

export function ProfileMenu(): JSX.Element {
  const isAuthenticated = useIsAuthenticated();
  const {logout, login} = useAuth();
  const currentUser = useCurrentUser();
  const [open, setOpen] = useState(false);
  const {t} = useTranslation();
  const {isLTR} = useAppDirection();

  return (
    <Dropdown
      placement={isLTR ? 'left-end' : 'right-end'}
      open={open}
      onOpenChange={setOpen}
      contentProps={{padding: 8}}
      header={
        <View
          onPress={(e) => {
            e.stopPropagation();
            e.preventDefault();
          }}>
          <XStack gap="$spacing-lg" alignItems="center">
            <Avatar size="sm" />
            <View>
              <Typography lineHeight="$1" fontSize="$text-sm" fontWeight="600" fontFamily="$body" color="$text-primary">
                {currentUser?.name ? currentUser?.name : <ShellTrans i18nKey="guest" />}
              </Typography>
              {currentUser?.email ? (
                <Typography
                  lineHeight="$1"
                  fontSize="$text-sm"
                  fontWeight="400"
                  fontFamily="$body"
                  color="$text-tertiary">
                  {currentUser?.email}
                </Typography>
              ) : null}
            </View>
          </XStack>
        </View>
      }
      trigger={
        <XStack alignItems="center" width="100%">
          <Avatar size="sm" />
        </XStack>
      }>
      <View
        onPress={(e) => {
          e.stopPropagation();
          e.preventDefault();
        }}>
        <LanguageLabel onPressLanguage={() => setOpen(false)} />

        <View height={1} marginVertical="$spacing-sm" backgroundColor="$border-secondary" />
        <DropdownItem
          onPress={() => {
            isAuthenticated ? logout() : login();
            setOpen(false);
          }}
          icon={isAuthenticated ? 'LogoutSquare02Icon' : 'LoginSquare02Icon'}
          iconSize={20}>
          {t(isAuthenticated ? 'logout' : 'login')}
        </DropdownItem>
      </View>
    </Dropdown>
  );
}
